import { V2Alert } from '@abyss/web/ui/Alert';
import { find } from 'lodash';

import { useLagoon } from '../../hooks/useLagoon';
import { ConstantsLagoon } from '../ConstantsLagoon';

export type Props = {
  onClose: () => void;
};

export const MedicalSpecialistBanner = ({ onClose }: Props) => {
  const uiMessaging = useLagoon('ui-messaging')();

  const cta = find(uiMessaging, {
    key: ConstantsLagoon.UI_MESSAGING.VIEW_VISION_COVERAGE_CTA_URL,
  });

  const ctaUrl = cta?.url;
  const ctaMessage = cta?.message;

  const title = find(uiMessaging, {
    key: ConstantsLagoon.UI_MESSAGING.MEDICAL_COVERAGE_ALERT_HEADER,
  })?.message;

  const description = find(uiMessaging, {
    key: ConstantsLagoon.UI_MESSAGING.MEDICAL_COVERAGE_ALERT_DESCRIPTION,
  })?.message;

  return (
    <V2Alert
      cta={{
        type: 'link',
        props: {
          children: ctaMessage,
          onClick: () => {
            window.location.href = ctaUrl;
          },
        },
      }}
      data-testid="medical-specialist-banner"
      onClose={onClose}
      status="info"
      title={title}
    >
      {description}
    </V2Alert>
  );
};
